import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

import styles from '../styles';
import utils from '../../common/utils';

class Button extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };
  }

  @autobind
  onMouseEnter() {
    this.setState({ hover: true });
  }

  @autobind
  onMouseLeave() {
    this.setState({ hover: false });
  }

  render() {
    const defaultColor = this.props.defaultColor;
    const hoverColor = this.props.hoverColor;

    let opacity;

    if (this.props.disabled) {
      opacity = '0.25';
    } else {
      opacity = '1';
    }

    const buttonStyles = {
      ...styles.button,
      backgroundColor: this.state.hover ? hoverColor : defaultColor,
      opacity,
    };

    const icon =
      this.state.hover && this.props.hoverIcon
        ? this.props.hoverIcon
        : this.props.icon;
    const iconStyles =
      this.props.iconType === 'image' ? styles.logoImage : styles.buttonIcon;

    return (
      <div
        ref={button => {
          this.button = button;
        }}
        style={buttonStyles}
        onClick={this.props.onPress}
        className={this.props.disabled ? 'disabled' : ''}
        onMouseEnter={utils.isMobileDevice() ? null : this.onMouseEnter}
        onMouseLeave={utils.isMobileDevice() ? null : this.onMouseLeave}
      >
        <span style={styles.buttonInner}>
          {this.props.iconType === 'image' ? (
            <img
              key={`button-image-${icon}`}
              src={icon}
              alt=""
              style={{
                ...iconStyles,
                width: this.props.iconWidth ? this.props.iconWidth : 'auto',
                height: this.props.iconHeight ? this.props.iconHeight : 'auto',
              }}
            />
          ) : (
            <i className={`icon-${icon}`} style={iconStyles} />
          )}
        </span>
        {this.props.children && (
          <span style={styles.buttonLabel}>{this.props.children}</span>
        )}
      </div>
    );
  }
}

Button.propTypes = {
  defaultColor: PropTypes.string,
  hoverColor: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  hoverIcon: PropTypes.string,
  iconType: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  children: PropTypes.array,
};

Button.defaultProps = {
  iconType: 'default',
  hoverIcon: null,
  defaultColor: 'transparent',
  hoverColor: 'rgba(255,255,255,0.25)',
  disabled: false,
};

export default Button;
